import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { errorMessage, successMessage } from "../CommonFunctions";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomInput from "../../../CustomControls/CustomInput";
import { SVGICON } from "../../../constant/theme";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import * as Yup from "yup";
import {
  POST_GetWhatsAppConfigurationInstanceTypeList,
  POST_WhatsAppConfigurationSave,
} from "../../../helpers/url_helper";

const WhatsAppConfiguration = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [showTemplateLabelModal, setShowTemplateLabelModal] = useState(false);

  const HeaderTypeOptions = [
    { label: "None", value: 0 },
    { label: "Document", value: 1 },
    { label: "Text", value: 2 },
  ];

  const validationSchema = Yup.object().shape({
    // ListOfInstanceType: Yup.array().of(
    //   Yup.object().shape({
    //     IsWhatsApp: Yup.boolean(),
    //     TemplateName: Yup.string().when("IsWhatsApp", {
    //       is: true,
    //       then: Yup.string()
    //         .required("Template Name is required when WhatsApp is selected.")
    //         .min(1, "Template Name cannot be empty."),
    //       otherwise: Yup.string(),
    //     }),
    //   })
    // ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ListOfInstanceType: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfInstanceType },
  } = formik;

  const handleValidSubmit = (values) => {
    let hasErrorTemplateName = false; // Flag to track errors
    let hasErrorHeaderTextName = false;

    values?.ListOfInstanceType?.forEach((p, index) => {
      if (p?.IsWhatsApp && !p?.TemplateName) {
        // formik.setFieldError(
        //   `ListOfInstanceType[${index}].TemplateName`,
        //   "Template Name is a required field."
        // );
        // formik.setFieldTouched(
        //   `ListOfInstanceType[${index}].TemplateName`,
        //   true
        // );
        hasErrorTemplateName = true; // Mark that an error exists
      }
      // Check if HeaderTextName is required but missing when HeaderType is 2
      if (p?.HeaderType === 2 && !p?.HeaderTextName) {
        hasErrorHeaderTextName = true;
        // formik.setFieldError(
        //   `ListOfInstanceType[${index}].HeaderTextName`,
        //   "Header Text Name is a required field"
        // );
        // formik.setFieldTouched(
        //   `ListOfInstanceType[${index}].HeaderTextName`,
        //   true
        // );
      }
    });

    if (hasErrorTemplateName) {
      formik.setFieldError(
        "ListOfInstanceType",
        "Template Name is required field"
      );
      formik.setFieldTouched("ListOfInstanceType", true);
      return;
    }
    if (hasErrorHeaderTextName) {
      formik.setFieldError(
        "ListOfInstanceType",
        "Header Text Name is required field"
      );
      formik.setFieldTouched("ListOfInstanceType", true);
      return;
    }

    setIsLoading(true);

    let payload = {
      ...values,
      ListOfInstanceType: values?.ListOfInstanceType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    //console.log("payload", payload);
    //return;

    post(POST_WhatsAppConfigurationSave, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getWhatsAppConfigurationList();
  }, []);

  const getWhatsAppConfigurationList = async () => {
    setIsLoading(true);

    await post(POST_GetWhatsAppConfigurationInstanceTypeList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfInstanceType",
            response?.ListOfInstanceType?.map((item, indx) => ({
              WhatsAppInstanceTypeIDEncrypted:
                item?.WhatsAppInstanceTypeIDEncrypted,
              WhatsAppInstanceType: item?.WhatsAppInstanceType,
              WhatsAppInstance: item?.WhatsAppInstance,
              SendTo: item?.SendTo,
              IsWhatsApp: item?.IsWhatsApp,
              HeaderType: item?.HeaderType ? item?.HeaderType : 0,
              HeaderTextName: item?.HeaderTextName,
              TemplateName: item?.TemplateName,
              CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
              BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
              WhatsAppConfigurationIDEncrypted:
                item?.WhatsAppConfigurationIDEncrypted,

              ListOfTemplateLabel: item?.ListOfTemplateLabel?.map(
                (itemsub, indxsub) => ({
                  WhatsAppConfigurationDetailIDEncrypted:
                    itemsub?.WhatsAppConfigurationDetailIDEncrypted,
                  WhatsAppConfigurationIDEncrypted:
                    itemsub?.WhatsAppConfigurationIDEncrypted,
                  TemplateLabelType: itemsub?.TemplateLabelType,
                  TemplateLabelName: itemsub?.TemplateLabelName,
                  Sequence:
                    itemsub?.Sequence == 0 ? indxsub + 1 : itemsub?.Sequence,
                  IsDeleted: false,
                  IsSelected: itemsub?.WhatsAppConfigurationIDEncrypted
                    ? itemsub?.IsSelected
                    : true,
                })
              ),
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const shouldHideRow = (AuthUser, item) => {
    if (AuthUser?.Permissions?.Account !== 1) {
      // Hide for specific InstanceTypes
      const hiddenInstanceTypes = [6, 7, 8, 9, 10, 11]; // 6 - Performa Invoice, 7 - Invoice, 8 - Unsettelment Receipt, 9 - Receipt, 10 - Credit Note, 11 - Outstanding
      if (hiddenInstanceTypes.includes(item?.InstanceType)) {
        return true;
      }
    }

    if (AuthUser?.Permissions?.DispatchMaterial !== 1) {
      if (item?.InstanceType === 5) {
        //5-Dispatch Material
        return true;
      }
    }

    return false; // Show the row
  };

  const validationTemplateLabel = Yup.object().shape({});

  const formikTemplateLabel = useFormik({
    validationSchema: validationTemplateLabel,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTemplateLabel(values, formikHelpers),
    initialValues: {
      ListOfTemplateLabel: [],
      ListIndex: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfTemplateLabel, ListIndex },
  } = formikTemplateLabel;

  const handleValidSubmitTemplateLabel = (values) => {};

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragSTParaEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      ListOfTemplateLabel,
      result.source.index,
      result.destination.index
    );

    let newList = [];
    items
      ?.filter((item) => item.IsDeleted === false)
      ?.map((x, idx) => {
        newList.push({
          ...x,
          Sequence: idx + 1,
        });
      });

    items
      ?.filter((item) => item.IsDeleted === true)
      ?.map((x, idx) => {
        newList.push({
          ...x,
          Sequence: 0,
        });
      });
    formikTemplateLabel.setFieldValue("ListOfTemplateLabel", newList);
  };

  const setTemplateLabelSequence = async () => {
    formik.setFieldValue(
      `ListOfInstanceType[${ListIndex}].ListOfTemplateLabel`,
      ListOfTemplateLabel
    );
    setShowTemplateLabelModal(false);
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="active-projects style-1">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">WhatsApp Configuration</h4>
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting">
                        <div
                          id="dashboard-tbl_wrapper"
                          className="dataTables_wrapper table-responsive no-footer"
                          // style={{ height: "700px", overflowY: "auto" }}
                        >
                          <table
                            id="dashboard-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="5%">WhatsApp</th>
                                <th width="20%">Instance</th>
                                <th width="20%">Send To</th>
                                <th width="20%">Template Name</th>
                                <th width="15%">Header Type</th>
                                <th width="20%">Header Text Name</th>
                                <th style={{ textAlign: "left" }}>
                                  Body Template
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfInstanceType?.length > 0 ? (
                                ListOfInstanceType?.map((item, indx) => (
                                  <tr
                                    key={indx}
                                    style={{
                                      display: shouldHideRow(AuthUser, item)
                                        ? "none"
                                        : "",
                                    }}
                                  >
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsWhatsApp${indx}`}
                                        name={`chkIsWhatsApp${indx}`}
                                        checked={item?.IsWhatsApp}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `ListOfInstanceType[${indx}].IsWhatsApp`,
                                            e?.target?.checked
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>{item?.WhatsAppInstance}</td>
                                    <td>{item?.SendTo}</td>
                                    <td className="d-items p-1">
                                      <Field
                                        type="text"
                                        name={`ListOfInstanceType.[${indx}].TemplateName`}
                                        component={CustomInput}
                                        placeholder="Template Name"
                                        noMarginBottom={true}
                                      />
                                    </td>
                                    <td>
                                      <Field
                                        name={`ListOfInstanceType[${indx}].HeaderType`}
                                        placeholder={"Header Type"}
                                        options={HeaderTypeOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        isClearable={false}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            `ListOfInstanceType[${indx}].HeaderType`,
                                            e?.value ?? ""
                                          );
                                        }}
                                      />
                                    </td>
                                    <td className="d-items p-1">
                                      {item?.HeaderType == 2 ? (
                                        <Field
                                          type="text"
                                          name={`ListOfInstanceType.[${indx}].HeaderTextName`}
                                          component={CustomInput}
                                          placeholder="Header Text Name"
                                          noMarginBottom={true}
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td
                                      style={{ textAlign: "left" }}
                                      className="d-items p-1"
                                    >
                                      <Link
                                        to="#"
                                        className="text-primary"
                                        title="Change Body"
                                        onClick={() => {
                                          formikTemplateLabel.setFieldValue(
                                            "ListOfTemplateLabel",
                                            ""
                                          );
                                          formikTemplateLabel.setFieldValue(
                                            "ListIndex",
                                            ""
                                          );
                                          formikTemplateLabel.setFieldValue(
                                            "ListOfTemplateLabel",
                                            item?.ListOfTemplateLabel
                                          );
                                          formikTemplateLabel.setFieldValue(
                                            "ListIndex",
                                            indx
                                          );
                                          setShowTemplateLabelModal(true);
                                        }}
                                      >
                                        Variables
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={6}
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    <div>{"No options"}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <ErrorMessage
                        name={"ListOfInstanceType"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                    </Col>
                  </Row>
                  <div className="stickyBottomButtons">
                    <hr className="mt-1 mb-2"></hr>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm me-2"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        navigate(-1);
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </div>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showTemplateLabelModal}
            onHide={setShowTemplateLabelModal}
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikTemplateLabel}>
                <Form onSubmit={formikTemplateLabel.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>Template Variables</Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowTemplateLabelModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={12}>
                        <div className="row">
                          <DragDropContext onDragEnd={onDragSTParaEnd}>
                            <div className="table-responsive active-projects style-1 shorting">
                              <div
                                id="TemplateLabelType-tbl_wrapper"
                                className="dataTables_wrapper table-responsive no-footer"
                                style={{
                                  maxHeight: "475px",
                                  overflow: "auto",
                                }}
                              >
                                <table
                                  id="TemplateLabelType-tbl"
                                  className="table dataTable no-footer mb-0"
                                >
                                  <thead>
                                    <tr>
                                      <th width="5%"></th>
                                      <th width="5%">Select</th>
                                      <th width="50%">Template Variable</th>
                                      <th
                                        width="10%"
                                        style={{
                                          textAlign: "left",
                                        }}
                                      >
                                        Sequence
                                      </th>
                                    </tr>
                                  </thead>
                                  <Droppable droppableId="droppableTemplateLabelTypeTable">
                                    {(provided, _) => (
                                      <tbody
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                      >
                                        {ListOfTemplateLabel?.length > 0 ? (
                                          ListOfTemplateLabel?.map(
                                            (item, indx) => (
                                              <Draggable
                                                key={`id_${indx}`}
                                                draggableId={`id_${indx}`}
                                                index={indx}
                                              >
                                                {(provided, _) => (
                                                  <tr
                                                    role="row"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    className={`sub-card draggable-handle draggable ${
                                                      item.IsDeleted == true &&
                                                      "d-none"
                                                    }`}
                                                  >
                                                    <td className="d-items p-1 text-center">
                                                      {SVGICON.Dotes}
                                                    </td>
                                                    <td className="d-items p-1 text-center">
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`chkTemplateLabelType${indx}`}
                                                        name={`chkTemplateLabelType${indx}`}
                                                        checked={
                                                          item?.IsSelected
                                                        }
                                                        onChange={(e) => {
                                                          formikTemplateLabel.setFieldValue(
                                                            `ListOfTemplateLabel[${indx}].IsSelected`,
                                                            e?.target?.checked
                                                          );
                                                        }}
                                                      />
                                                    </td>

                                                    <td
                                                      className="d-items p-1"
                                                      style={{
                                                        minWidth: "80px",
                                                      }}
                                                    >
                                                      {item.TemplateLabelName}
                                                    </td>

                                                    <td
                                                      className="d-items p-1"
                                                      style={{
                                                        minWidth: "80px",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      {item?.Sequence}
                                                    </td>
                                                  </tr>
                                                )}
                                              </Draggable>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              style={{
                                                textAlign: "left",
                                              }}
                                            >
                                              <div>{"No Record Found..."}</div>
                                            </td>
                                          </tr>
                                        )}
                                        {provided.placeholder}
                                      </tbody>
                                    )}
                                  </Droppable>
                                </table>
                              </div>
                            </div>
                            <ErrorMessage
                              name={"ListOfTemplateLabel"}
                              component="div"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            />
                          </DragDropContext>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="primary btn-sm"
                      type="button"
                      onClick={(e) => {
                        setTemplateLabelSequence();
                      }}
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Save
                    </Button>

                    <Button
                      variant="danger btn-sm"
                      onClick={() => {
                        setShowTemplateLabelModal(false);
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default WhatsAppConfiguration;
